import React, { memo, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

interface ILoadingConfig {
  visible: boolean,
  type: 'success'|'loading'|'fail',
  text: string,
  afterClose: () => void
}

const ULoading = (props: ILoadingConfig) => {
  const { type, text, visible, afterClose } = props;
  const [ show, setShow ] = useState(visible);
  const [ imgSrc ] = useState(`https://static.iyb.tm/web/h5/activity/202204/loading/${type}.png`);
  useEffect(() => {
    let timer: null|number = null;
    if (type !== 'loading') {
      timer = setTimeout(() => {
        setShow(false);
        timer && clearTimeout(timer);
      }, 1500);
    } else {
      setShow(true);
    }
  },[type]);
  useEffect(() => {
    if (!show && afterClose) {
      afterClose();
    }
  },[show, afterClose]);
  // 防止弹框多次创建
  if(document.getElementsByClassName('loading').length) {
    return <></>;
  }
  return (
    show ? createPortal(
      <div className='loading'>
        <div className='content'>
          <img 
            className={type==='loading'?'circle':''} 
            style={{marginTop: text.length > 7 ? '19px':''}}
            src={imgSrc} 
            alt={type} 
          />
          <div className={type==='loading'?'loadDiv':''}>{text}</div>
        </div>
      </div>, document.body
    ) : <></>
  );
};
// 属性约束
ULoading.propTypes = {
  type: PropTypes.string,
  visible: PropTypes.bool,
  text: PropTypes.string,
  afterClose: PropTypes.func
};
// 默认属性
ULoading.defaultProps ={
  type: 'loading',
  visible: false,
  text: '加载中',
  afterClose: null
};

export default memo(ULoading) ;